/* tslint:disable */
/* eslint-disable */
/**
 * Marsinet API
 * Esta API es utilizada tanto por Marsinet como por MarsiConnect. Proporciona todos los endpoints actualizados y documentación detallada, incluyendo ejemplos de datos y mocks de prueba para verificar el comportamiento de cada llamada.
 *
 * OpenAPI spec version: 5.0.1
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import { ColumnDto } from './column-dto';
/**
 *
 *
 * @export
 * @interface FilterDto
 */
export interface FilterDto {
  /**
   * @type {ColumnDto}
   * @memberof FilterDto
   */
  column: ColumnDto;

  /**
   * @type {string}
   * @memberof FilterDto
   * @example eq
   */
  operator: FilterDtoOperatorEnum;

  /**
   * Omit for IS_NULL / IS_NOT_NULL. Use array for IN.
   *
   * @type {any}
   * @memberof FilterDto
   * @example US
   */
  value?: any;
}

/**
 * @export
 * @enum {string}
 */
export enum FilterDtoOperatorEnum {
  IsNull = 'is_null',
  IsNotNull = 'is_not_null',
  In = 'in',
  NotIn = 'not_in',
  Like = 'like',
  NotLike = 'not_like',
  Ilike = 'ilike',
  NotIlike = 'not_ilike',
  Regexp = 'regexp',
  NotRegexp = 'not_regexp',
  Eq = 'eq',
  Neq = 'neq',
  Gt = 'gt',
  Lt = 'lt',
  Gte = 'gte',
  Lte = 'lte',
  Between = 'between',
  NotBetween = 'not_between',
}
